// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"cbd2ed8b","606":"abe66891","610":"4d0d2e6a","816":"cdc82263"}[chunkId] + ".chunk.js";
};